import React, { useCallback, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import api from '../api/client';

const AdminPayments = () => {
  const [data, setData] = useState(null);
  const load = useCallback(() => api.get('/api/admin/payments/reconciliation/').then((r) => setData(r.data)).catch(() => toast.error('Failed to load')), []);
  useEffect(() => { load(); }, [load]);

  const setUtr = async (row) => {
    const utr = window.prompt('Escrow statement UTR for this receipt:', row.escrow_utr || '');
    if (utr === null) return;
    try { await api.patch(`/api/admin/payments/${row.payment_id}/`, { escrow_utr: utr.trim() }); load(); } catch (e) { toast.error('Could not save'); }
  };
  const refund = async (row) => {
    if (!window.confirm(`Refund ₹${row.amount} to ${row.investor}?`)) return;
    try { await api.post(`/api/admin/payments/${row.payment_id}/refund/`); toast.success('Refund issued'); load(); }
    catch (e) { toast.error(e.response?.data?.detail || 'Refund failed'); }
  };
  const csv = async () => {
    const res = await api.get('/api/admin/payments/reconciliation/', { params: { format_csv: 1 }, responseType: 'blob' });
    const a = document.createElement('a');
    a.href = URL.createObjectURL(res.data); a.download = 'reconciliation.csv'; a.click();
  };

  if (!data) return <main style={{ padding: '4rem 1rem', textAlign: 'center' }}><p>Loading…</p></main>;
  return (
    <main style={{ maxWidth: 1200, margin: '0 auto', padding: '2rem 1rem' }}>
      <h1>Payments and reconciliation</h1>
      <button onClick={csv}>Download CSV</button>
      <h2>Totals by SPV (₹)</h2>
      <table><thead><tr><th>SPV</th><th>Gateway received</th><th>Escrow confirmed</th><th>Unmatched</th><th>Refunded</th><th>Exceptions</th></tr></thead>
        <tbody>{Object.entries(data.totals).map(([n, t]) => (
          <tr key={n}><td>{n}</td><td>{t.gateway_received}</td><td>{t.escrow_confirmed}</td><td>{t.unmatched}</td><td>{t.refunded}</td><td>{t.exceptions}</td></tr>
        ))}</tbody></table>
      <h2>Payments</h2>
      <div style={{ overflowX: 'auto' }}>
        <table>
          <thead><tr><th>Investor</th><th>SPV</th><th>Amount</th><th>Status</th><th>Gateway payment</th><th>Escrow UTR</th><th>Flag</th><th /></tr></thead>
          <tbody>{data.rows.map((r) => (
            <tr key={r.payment_id}>
              <td>{r.investor}</td><td>{r.spv}</td><td>₹{Number(r.amount).toLocaleString('en-IN')}</td>
              <td>{r.status}{r.refund_utr && ` (UTR ${r.refund_utr})`}</td><td>{r.gateway_payment_id || r.gateway_order_id}</td>
              <td>{r.escrow_utr || '-'}</td><td>{r.exception || (r.unmatched ? 'no escrow UTR' : '')}</td>
              <td>{r.status === 'success' && <><button onClick={() => setUtr(r)}>Set escrow UTR</button>{' '}<button onClick={() => refund(r)}>Refund</button></>}</td>
            </tr>
          ))}</tbody>
        </table>
      </div>
    </main>
  );
};

export default AdminPayments;
